import { Button } from "../Button/Button";
import "./TabSwitcher.scss";

type Props = {
  Tabs: Array<Tab>;
  selectedTab: string;
  onTabClick: (tabId: string) => void;
  maxCharacters?: number;
};

type Tab = {
  id: string;
  text: string;
  notification?: number;
};

const TabSwitcher = ({ Tabs, maxCharacters = 5, selectedTab, onTabClick }: Props) => {
  const shouldWrapToggleSwitch = Tabs.some((tab) => tab.text.length >= maxCharacters);

  return (
    <div className={`TabSwitcher TabSwitcher${shouldWrapToggleSwitch ? "--column" : ""}`}>
      {Tabs.map((tab) => (
        <Button
          id={`TabSwitcher_${tab.id}`}
          key={tab.id}
          data-text={tab.text}
          className={`TabSwitcher__button TabSwitcher__button${selectedTab === tab.id ? "--active" : ""}`}
          onClick={() => onTabClick(tab.id)}
        >
          {tab.text}
          {tab.notification !== undefined && tab.notification > 0 && (
            <span className="TabSwitcher__notificationPill" aria-hidden="true">
              {tab.notification}
            </span>
          )}
        </Button>
      ))}
    </div>
  );
};

export default TabSwitcher;
